import request from '@/request'
const part_url = '/train/web/course/';

function getCourseList(data) {
    let url = part_url + "courselist";
    return request.get(url, data)
}


function getCourseShouYeList(data) {
    let url = part_url + "courseSylist";
    return request.get(url, data)
}


function getCourseListByLecturer(lecturerId) {
    let url = part_url + "courselistByLecturer";
    return request.get(url, {lecturerId})
}

function getCourseDetail(id) {
    let url = part_url + "getById";
    return request.get(url, {id})
}

/**
 * 获取相关课程信息
 */
function getKeChengList() {
    let url = part_url + "keChengList";;
    return request.get(url, {})
}
export default {
    getCourseList,
    getCourseListByLecturer,
    getCourseDetail,
    getKeChengList,
    getCourseShouYeList
}



// WEBPACK FOOTER //
// ./src/api/course.js